import { render, staticRenderFns } from "./prooWriteful.vue?vue&type=template&id=2e6c7f73&scoped=true"
import script from "./prooWriteful.vue?vue&type=script&lang=js"
export * from "./prooWriteful.vue?vue&type=script&lang=js"
import style0 from "./prooWriteful.vue?vue&type=style&index=0&id=2e6c7f73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c7f73",
  null
  
)

export default component.exports